import React, { useState } from "react";
import Layout from "../../components/Layout";
import { motion } from "framer-motion";
import Top from "../../components/Top";
import emailjs from "@emailjs/browser";
import { Toaster, toast } from "react-hot-toast";
import Trains from "./Trains";

function Training() {
	const [email, setEmail] = useState("");

	const handleSubmit = (e) => {
		e.preventDefault();
		//keys and services
		const templateId = "template_k06u98r";
		const publicKey = "vRKpOxPaAllPvKD00";
		const serviceId = "service_1icj9w8";

		//create new object

		const templateParams = {
			to_name: "Africa55Durable Email News request",
			from_email: email,
		};

		//send theEmail
		emailjs
			.send(serviceId, templateId, templateParams, publicKey)
			.then((response) => {
				console.log("Message successfully sent", response);
				setEmail("");
			})
			.catch((error) => {
				console.error("Error sending", error);
			});

		//////////
		const refreshToast = toast.loading(
			"Your message has been sent. We will shortly contact you"
		);
		toast.success("Your message has been sent. We will shortly contact you", {
			id: refreshToast,
			duration: 7000,
		});

		/// navigate to
	};
	return (
		<Layout>
			<Top />
			<Toaster />
			<>
				<motion.div className="flex flex-1 justify-center mt-6 ">
					<p className=" border-b-8 border-emerald-800 pb-2 text-2xl w-fit text-orange-500">
						Coming soon Trainings
					</p>
				</motion.div>
				<p className=" flex flex-1 text-xl italic text-black font-extralight justify-center mt-5 text-center ">
					We keep you posted on daily motion and trends in the alternative
					development world.
				</p>
				<div className="sm:flex w-full overflow-x-auto  overflow-hidden  scrollbar-hide ">
					<Trains />
				</div>

				<div className="bg-emerald-300 sm:flex justify-center hidden items-center space-x-6 rounded-md py-4 mt-6 mx-40">
					<p className="italic text-lg">
						{" "}
						send your Email to receive latest posts
					</p>

					<from onSubmit={handleSubmit} className="text-black">
							<div className="flex items-center space-x-4 text-black">
								<input
									type="email"
									placeholder="Email"
									className="w-full m-2    p-2 outline-none  text-black rounded-md"
									value={email}
									onChange={(e) => setEmail(e.target.value)}
								/>
								<p className=" bg-teal-600 hover:bg-teal-400  px-4 font-light text-white hover:text-black rounded-full cursor-pointer">
									Send
								</p>
							</div>
						</from>
				</div>


				<div className="bg-emerald-300 flex flex-col sm:hidden items-center space-y-6 rounded-md py-4 mt-6 px-6">
					<p className="italic text-lg">
						{" "}
						send your Email to receive latest posts
					</p>

					
					<from onSubmit={handleSubmit} className="text-black">
							<div className="flex items-center space-x-4 text-black">
								<input
									type="email"
									placeholder="Email"
									className="w-full m-2 bg-white   p-2 outline-none  text-black rounded-md"
									value={email}
									onChange={(e) => setEmail(e.target.value)}
								/>
								<p className=" bg-teal-600 hover:bg-teal-400  px-4 font-light text-white hover:text-black rounded-full cursor-pointer">
									Send
								</p>
							</div>
						</from>




				</div>
			</>
		</Layout>
	);
}

export default Training;
